// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"84e42cad","332":"37a86a14","395":"d52eea40","802":"d52eea40","869":"bf8f9e35","964":"82cb7372"}[chunkId] + ".chunk.css";
};